/* IPL product sections: step carousel (md-ipl-steps) and match checker (md-ipl-match). */
(() => {
  if (!customElements.get('md-ipl-steps')) {
    class MdIplSteps extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('.md-steps__tab')];
        this.panels = [...this.querySelectorAll('.md-steps__panel')];
        if (this.tabs.length) {
          this.panels.forEach((p, i) => (p.hidden = i !== 0));
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => {
              if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
              e.preventDefault();
              const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            });
          });
        }
        this.panels.forEach((panel) => this.setupPanel(panel));
      }

      select(index) {
        this.tabs.forEach((t, i) => {
          const on = i === index;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((p, i) => (p.hidden = i !== index));
        const panel = this.panels[index];
        const track = panel.querySelector('.md-steps__track');
        track.scrollTo({ left: 0 });
        this.update(panel);
      }

      setupPanel(panel) {
        const track = panel.querySelector('.md-steps__track');
        panel.querySelectorAll('.md-steps__btn').forEach((btn) => {
          btn.addEventListener('click', () => {
            const card = track.querySelector('.md-steps__card');
            if (!card) return;
            const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
            track.scrollBy({ left: step * Number(btn.dataset.dir), behavior: 'smooth' });
          });
        });
        let raf;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.update(panel));
        }, { passive: true });
        this.update(panel);
      }

      update(panel) {
        const track = panel.querySelector('.md-steps__track');
        const cards = [...track.querySelectorAll('.md-steps__card')];
        if (!cards.length) return;
        const left = track.getBoundingClientRect().left;
        let current = 0;
        cards.forEach((c, i) => {
          if (c.getBoundingClientRect().left - left < c.offsetWidth / 2) current = i;
        });
        const max = track.scrollWidth - track.clientWidth;
        const visible = Math.max(1, Math.round(track.clientWidth / cards[0].offsetWidth));
        if (max <= 2) current = cards.length - 1;
        else if (track.scrollLeft >= max - 2) current = cards.length - 1;
        const shown = Math.min(cards.length, current + 1);
        const first = Math.min(cards.length - visible, current);
        panel.querySelector('.md-steps__count').textContent =
          visible > 1 && max > 2 ? `${first + 1}–${Math.min(cards.length, first + visible)} / ${cards.length}` : `${shown} / ${cards.length}`;
        panel.querySelector('.md-steps__bar').style.width = `${(shown / cards.length) * 100}%`;
        const [prev, next] = panel.querySelectorAll('.md-steps__btn');
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        panel.classList.toggle('md-steps__panel--static', max <= 2);
      }
    }
    customElements.define('md-ipl-steps', MdIplSteps);
  }

  if (!customElements.get('md-ipl-match')) {
    class MdIplMatch extends HTMLElement {
      connectedCallback() {
        this.result = this.querySelector('.md-match__result');
        this.addEventListener('change', () => this.update());
        this.update();
      }

      update() {
        const skin = this.querySelector('input[name^="md-skin"]:checked');
        const hair = this.querySelector('input[name^="md-hair"]:checked');
        const title = this.result.querySelector('.md-match__result-title');
        const text = this.result.querySelector('.md-match__result-text');
        const d = this.dataset;
        let state = 'wait';
        let t = d.wait;
        let body = '';
        if (skin && skin.dataset.levels.trim() === '') {
          state = 'no';
          t = d.noTitle;
          body = d.noSkin;
        } else if (hair && hair.dataset.ok !== 'true') {
          state = 'no';
          t = d.noTitle;
          body = d.noHair;
        } else if (skin && hair) {
          state = 'ok';
          t = d.okTitle;
          // word joiners keep a range such as "3–5" on one line
          body = d.okText.replace('[levels]', skin.dataset.levels.trim().replace(/([–-])/g, '⁠$1⁠'));
        } else if (skin || hair) {
          t = skin ? 'Now tap your hair colour.' : 'Now tap your skin tone.';
        }
        this.result.dataset.state = state;
        title.textContent = t;
        text.textContent = body;
        text.hidden = !body;
      }
    }
    customElements.define('md-ipl-match', MdIplMatch);
  }
})();
